import { render, staticRenderFns } from "./ListsArticles.vue?vue&type=template&id=825ade88&scoped=true"
import script from "./ListsArticles.vue?vue&type=script&lang=js"
export * from "./ListsArticles.vue?vue&type=script&lang=js"
import style0 from "./ListsArticles.vue?vue&type=style&index=0&id=825ade88&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "825ade88",
  null
  
)

export default component.exports